import _classCallCheck from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/createClass";
export var Service = /*#__PURE__*/function () {
  function Service() {
    _classCallCheck(this, Service);

    this.framework = {};
  }

  _createClass(Service, [{
    key: "init",
    value: function init(root, ssrContext) {}
  }]);

  return Service;
}();